import React from 'react'

const PadlockRecoverIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="135" height="105" viewBox="0 0 135 105" {...props}>
    <defs>
      <clipPath id="PadlockRecover">
        <path fill="#fff" d="M0 0h135v105H0z" transform="translate(-2122 2732)"/>
      </clipPath>
    </defs>
    <g clipPath="url(##PadlockRecover)" transform="translate(2122 -2732)">
      <g>
        <g opacity=".355" transform="translate(-2121 2739.541)">
          <circle cx="4.213" cy="4.213" r="4.213" fill="#fcb844" transform="translate(119.771 79.377)"/>
          <circle cx="5.503" cy="5.503" r="5.503" fill="#2cc2b1" transform="translate(0 53.362)"/>
          <circle cx="4.739" cy="4.739" r="4.739" fill="#2cc2b1" transform="translate(98.934)"/>
          <circle cx="4.344" cy="4.344" r="4.344" fill="#5facff" transform="translate(123.75 32.138)"/>
          <circle cx="3.159" cy="3.159" r="3.159" fill="#f65257" transform="translate(11.44 3.509)"/>
        </g>
        <g>
          <path fill="#5facff" d="M-2078.194 2815.682a6.814 6.814 0 01-6.806-6.808v-42.542a1.7 1.7 0 011.7-1.7h5.106v-6.808a23.824 23.824 0 1147.648 0v6.808h5.1a1.7 1.7 0 011.7 1.7v42.542a6.814 6.814 0 01-6.8 6.808zm10.212-57.852v6.808h27.226v-6.814a13.614 13.614 0 10-27.228 0z"/>
          <g>
            <g fill="#fff">
              <path d="M-2060.457 2780.181a1.294 1.294 0 001.2.7 1.415 1.415 0 00.715-.207c.238-.136.518-.292.838-.459a6.608 6.608 0 011.148-.464 5.756 5.756 0 011.666-.207 2.939 2.939 0 012.042.671 2.288 2.288 0 01.744 1.8 3.125 3.125 0 01-.442 1.687 5.989 5.989 0 01-1.082 1.278 13.009 13.009 0 01-1.374 1.075 10.881 10.881 0 00-1.327 1.052 4.348 4.348 0 00-.932 1.242 2.61 2.61 0 00-.188 1.609l.414 3.031h3.991l.527-2.635a2.122 2.122 0 01.612-1.054 10.783 10.783 0 011.129-.951q.649-.48 1.374-1.045a7.677 7.677 0 001.327-1.337 6.848 6.848 0 001-1.816 6.977 6.977 0 00.4-2.475 6.8 6.8 0 00-.536-2.739 5.9 5.9 0 00-1.534-2.108 6.972 6.972 0 00-2.419-1.346 10.148 10.148 0 00-3.191-.471 11.99 11.99 0 00-2.344.216 10.965 10.965 0 00-2.024.6 11.977 11.977 0 00-1.76.894 12.924 12.924 0 00-1.515 1.094z"/>
              <path d="M-2058.282 2801.049a3.232 3.232 0 00.7 1.026 3.185 3.185 0 001.045.675 3.475 3.475 0 001.318.245 3.439 3.439 0 001.3-.245 3.3 3.3 0 001.054-.675 3.146 3.146 0 00.706-1.026 3.2 3.2 0 00.254-1.273 3.114 3.114 0 00-.96-2.278 3.459 3.459 0 00-1.054-.687 3.313 3.313 0 00-1.3-.254 3.334 3.334 0 00-2.362.941 3.217 3.217 0 00-.7 1.016 3.129 3.129 0 00-.254 1.261 3.2 3.2 0 00.253 1.274z"/>
            </g>
          </g>
        </g>
        <g transform="translate(-45 -107)">
          <rect width="101" height="29" fill="#f2f2f2" rx="12" transform="translate(-2060 2913.089)"/>
          <g>
            <g fill="#969799">
              <path d="M-2031.224 2933.581h-9.112a1.3 1.3 0 100 2.6h9.112a1.3 1.3 0 100-2.6z"/>
              <path d="M-2012.231 2933.581h-9.112a1.3 1.3 0 100 2.6h9.112a1.3 1.3 0 000-2.6z"/>
              <path d="M-1993.711 2933.581h-9.112a1.3 1.3 0 100 2.6h9.112a1.3 1.3 0 100-2.6z"/>
              <path d="M-1975.842 2933.581h-9.112a1.3 1.3 0 000 2.6h9.112a1.3 1.3 0 100-2.6z"/>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default PadlockRecoverIcon;
